module.exports = __webpack_public_path__ + "img/bus.df7b4fcb.png";